import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import useInvalidateShop from "./use-invalidate-shop";

type UseRemoveTeamInvitationParams = {
	onSuccess?: () => void;
	onError?: () => void;
};

export default function useDeleteTeamInvitation(
	shopId: string,
	email: string,
	options?: UseRemoveTeamInvitationParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const mutation = $api.useMutation(
		"delete",
		"/shops/{shopId}/members/{email}/invitations",
	);
	const invalidateShop = useInvalidateShop(shopId);

	return useMutation({
		onSuccess: () => {
			invalidateShop();
			successNotification();
			options?.onSuccess?.();
		},
		onError: () => {
			errorNotification();
			options?.onError?.();
		},
		mutationFn: async () => {
			return mutation.mutateAsync({
				params: { path: { shopId, email } },
			});
		},
	});
}
